// extracted by mini-css-extract-plugin
export default {"myDaos":"styles_myDaos__rUXU2"};